import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from '@mui/material';
import React, { forwardRef } from 'react';
import { LoadingButton } from '@mui/lab';
import { Button } from '../Button';
import { ModalBase } from './ModalBase';
export const Modal = /*#__PURE__*/ forwardRef(function Modal({ children, primaryButtonDanger = false, primaryButtonDisabled = false, primaryButtonLoading = false, onClose, onPrimaryButtonClick, primaryButtonText, secondaryButtonText, ...rest }, ref) {
    return /*#__PURE__*/ _jsx(ModalBase, {
        onClose: onClose,
        ref: ref,
        Footer: /*#__PURE__*/ _jsx(Box, {
            p: 1,
            justifyContent: "flex-end",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            children: /*#__PURE__*/ _jsxs(Stack, {
                direction: "row",
                spacing: 1,
                children: [
                    onPrimaryButtonClick && /*#__PURE__*/ _jsx(LoadingButton, {
                        variant: "contained",
                        color: primaryButtonDanger ? 'error' : 'primary',
                        loading: primaryButtonLoading,
                        onClick: onPrimaryButtonClick,
                        disabled: primaryButtonDisabled,
                        children: /*#__PURE__*/ _jsx("span", {
                            children: primaryButtonText || 'Ok'
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "secondary",
                        onClick: onClose,
                        children: secondaryButtonText || 'Cancel'
                    })
                ]
            })
        }),
        ...rest,
        children: children && /*#__PURE__*/ _jsx(Box, {
            px: 2,
            sx: {
                paddingBottom: onPrimaryButtonClick === undefined ? 1 : 0
            },
            children: children
        })
    });
});

//# sourceMappingURL=Modal.js.map